module.exports = __webpack_public_path__ + "img/peiicon4.36ba6381.svg";